import { useState } from 'react';
import { useSaveWarningMutation } from 'services/api/home';
import { ResponseError } from 'services/api/base';
import { useHandleRequestErrors } from 'utils/hooks';

const DEFAULT_EXPIRATION_TIME = 48;

export default function useSaveWarning(refetch: () => void) {
  const [saveTrigger, { error: saveError }] = useSaveWarningMutation();
  const [id, setId] = useState(0);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [expirationTime, setExpirationTime] = useState<number>(DEFAULT_EXPIRATION_TIME);
  const [formHeader, setFormHeader] = useState('Novo aviso');
  const [formOpen, setFormOpen] = useState(false);
  const [formValidated, setFormValidated] = useState(false);

  useHandleRequestErrors(saveError as ResponseError);

  const openForm = (
    initialId = 0,
    initialTitle = '',
    initialMessage = '',
    initialExpirationTime = DEFAULT_EXPIRATION_TIME,
  ) => {
    setId(initialId);
    setTitle(initialTitle);
    setMessage(initialMessage);
    setExpirationTime(initialExpirationTime);
    setFormHeader(initialId === 0 ? 'Novo aviso' : 'Editar aviso');
    setFormOpen(true);
  };

  const closeForm = () => {
    setFormValidated(false);
    setFormOpen(false);
  };

  const saveWarning = async () => {
    if (!title || !message || !expirationTime) {
      setFormValidated(true);
      return;
    }

    try {
      await saveTrigger({
        id,
        title,
        message,
        expirationTime,
      });
    } finally {
      closeForm();
      refetch();
    }
  };

  return {
    id,
    title,
    setTitle,
    message,
    setMessage,
    expirationTime,
    setExpirationTime,
    formHeader,
    formOpen,
    formValidated,
    openForm,
    closeForm,
    saveWarning,
  };
}
